/* eslint-disable */

import React, { Component } from 'react'
import dropdown from './dropdown'
import Icon from './icon'
import classnames from 'classnames'

@dropdown
export default class MultiSelectMenu extends Component {

  handleRemoveFor = option => event => {
    event.preventDefault()
    this.props.onRemove(option)
  }

  handleAddFor = option => event => {
    event.preventDefault()
    this.props.onAdd(option)
  }

  getSelectedLabel() {
    const { selected, options } = this.props
    switch(selected.length) {
      case 0: {
        return this.props.noneLabel || 'None Selected'
      }
      case 1: {
        const option = options.find(o => o === selected[0] || o.value === selected[0])
        return option ? (option.label || option) : (this.props.noneLabel || 'None Selected')
      }
      default: {
        return this.props.multiLabel || 'Multiple Selected'
      }
    }
  }

  getOptions() {
    const { selected, options } = this.props
    return options.map(option => {
      const value = option.value ? option.value : option
      const label = option.label ? option.label : option
      if (selected.includes(value)) {
        return (
          <div key={value} className="sidx-multiselect-item sidx-selected" onClick={this.handleRemoveFor(value)}>
            <div style={{ width: '20px' }}><Icon symbol="check" /></div>
            {label}
          </div>
        )
      }
      return (
        <div key={value} className="sidx-multiselect-item" onClick={this.handleAddFor(value)}>
          <div style={{width: '20px'}}></div>
          {label}
        </div>
      )
    })
  }

  getDropdown() {
    return this.props.dropdown({
      content: (
        <div className="sidx-select-menu-content" onMouseDown={(e) => {}}>
          <span className="sidx-select-menu-selection">
            {this.getSelectedLabel()} <Icon symbol="chevron-down" />
          </span>
        </div>
      ),
      dropdown: (
        <div className="sidx-select-menu-dropdown">
          {this.getOptions()}
        </div>
      )
    })
  }

  render() {
    const className = classnames('sidx-select-menu', {
      'sidx-no-frame': this.props.noFrame
    })
    return (
      <div className={className}>
        {this.getDropdown()}
      </div>
    )
  }
}



// WEBPACK FOOTER //
// client/components/multi_select.js